import { Search } from "lucide-react";

const Pills = ({ value, onChange, options, testid }) => (
  <div className="inline-flex rounded-full border border-[#A8B59A]/30 bg-white p-1" data-testid={testid}>
    {options.map(([v, label]) => (
      <button
        key={v}
        onClick={() => onChange(v)}
        data-testid={`${testid}-${v}`}
        aria-pressed={value === v}
        className={`px-4 py-1.5 text-xs rounded-full transition-colors ${value === v ? "bg-[#59394F] text-white" : "text-[#5A433B] hover:bg-[#A8B59A]/10"}`}
      >
        {label}
      </button>
    ))}
  </div>
);

export const ProductFilters = ({ q, setQ, category, setCategory, visibility, setVisibility, photos, setPhotos, shown, total }) => (
  <div className="flex flex-wrap items-center gap-3 mb-6" data-testid="product-filters">
    <label className="relative flex-1 min-w-[220px] max-w-sm">
      <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5E4D5A]" />
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search by product name"
        data-testid="product-search"
        className="w-full rounded-full border border-[#A8B59A]/30 bg-white pl-9 pr-4 py-2 text-sm focus:outline-none focus:border-[#59394F]"
      />
    </label>
    <Pills value={category} onChange={setCategory} testid="filter-category"
      options={[["all", "All categories"], ["research", "Research"], ["skincare", "Skincare"]]} />
    <Pills value={visibility} onChange={setVisibility} testid="filter-visibility"
      options={[["all", "All"], ["visible", "Visible"], ["hidden", "Hidden"]]} />
    <Pills value={photos} onChange={setPhotos} testid="filter-photos"
      options={[["all", "Any photos"], ["none", "No photos yet"]]} />
    <span className="text-xs text-[#5E4D5A]" data-testid="product-count">Showing {shown} of {total}</span>
  </div>
);
